import type { SVGAttributes } from 'react';

export function BeneficiariesIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				opacity="0.34"
				d="M11.1719 16.0001L14.3852 19.2268L20.8252 12.7734"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.3319 3.26676C15.2519 2.48009 16.7585 2.48009 17.6919 3.26676L19.7985 5.08009C20.1985 5.42676 20.9452 5.70676 21.4785 5.70676H23.7452C25.1585 5.70676 26.3185 6.86676 26.3185 8.28009V10.5468C26.3185 11.0668 26.5985 11.8268 26.9452 12.2268L28.7585 14.3334C29.5452 15.2534 29.5452 16.7601 28.7585 17.6934L26.9452 19.8001C26.5985 20.2001 26.3185 20.9468 26.3185 21.4801V23.7468C26.3185 25.1601 25.1585 26.3201 23.7452 26.3201H21.4785C20.9585 26.3201 20.1985 26.6001 19.7985 26.9468L17.6919 28.7601C16.7719 29.5468 15.2652 29.5468 14.3319 28.7601L12.2252 26.9468C11.8252 26.6001 11.0785 26.3201 10.5452 26.3201H8.23854C6.82521 26.3201 5.66521 25.1601 5.66521 23.7468V21.4668C5.66521 20.9468 5.38521 20.2001 5.05187 19.8001L3.25188 17.6801C2.47854 16.7601 2.47854 15.2668 3.25188 14.3468L5.05187 12.2268C5.38521 11.8268 5.66521 11.0801 5.66521 10.5601V8.26676C5.66521 6.85342 6.82521 5.69342 8.23854 5.69342H10.5452C11.0652 5.69342 11.8252 5.41342 12.2252 5.06676L14.3319 3.26676Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
